export const unableToLoadPlacesSettingsTitle = "pzwzjd";
export const unableToLoadPlacesSettings = "jhaHrd";
export const unableToLoadPlacesSettingsButtonLabel = "nRc_Ie";
export default {unableToLoadPlacesSettingsTitle,unableToLoadPlacesSettings,unableToLoadPlacesSettingsButtonLabel};